import { FormControl, InputLabel, MenuItem, Select } from '@mui/material'
import IntakeCard from 'candidate/components/IntakeCard'
import { QuestionWrapper } from 'candidate/components/QuestionWrapper'
import { ChoiceBucket } from 'candidate/models/intake'
import { useEffect, useState } from 'react'
import NextButton from 'shared/components/NextButton'

import { Dispatch, FC } from 'react'

interface Props {
    internalName: string
    answer?: ChoiceBucket
    callback: Dispatch<any>
    choices: ChoiceBucket[]
    prompt: string
    displayName: string
    subtext?: string
}

const DropdownQuestion: FC<Props> = ({
    internalName,
    answer,
    callback,
    choices,
    prompt,
    displayName,
    subtext,
}: Props) => {
    const dropdownOptions = choices.map((choice: ChoiceBucket) => {
        return choice.choice
    })
    const [response, setResponse] = useState<ChoiceBucket | undefined>(answer)

    useEffect(() => {
        if (answer) {
            setResponse(answer)
        }
    }, [answer])

    return (
        <IntakeCard question={prompt} subtext={subtext}>
            <QuestionWrapper>
                <FormControl fullWidth>
                    <InputLabel id={`${internalName}_label`}>
                        {displayName}
                    </InputLabel>

                    <Select
                        label={displayName}
                        labelId={`${internalName}_label`}
                        id={internalName}
                        value={response?.choice || ''}
                        onChange={(e) => {
                            const selection = choices.find(
                                (choice: ChoiceBucket) =>
                                    choice.choice === e.target.value
                            )
                            setResponse(selection)
                        }}
                    >
                        {dropdownOptions.map((option) => (
                            <MenuItem key={option} value={option}>
                                {option}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </QuestionWrapper>

            <NextButton
                disabled={response ? false : true}
                onClickHandler={() => callback({ response })}
            />
        </IntakeCard>
    )
}

export default DropdownQuestion
